import { JobStatusType } from "@nova/constants"
import { OrthoFlight } from "@nova/protobuf"
import { selectOrthoImagesAndUploadsByFlightId } from "features/entity-caching/images/orthos/selectors"
import { selectActivatedFireId } from "features/map/control/selectors"
import { activateFlightPath } from "features/map/layers/slice"
import { takeMapSnapshot } from "features/map/module"
import { zoomToShowFlightPath } from "features/map/zoom/thunks"
import store from "integrations/redux/store"
import {
    selectOrthoFlightIsBoundingBoxShowing,
    toggleActiveOrthophoto,
} from "plugins/Orthomosaic/OrthomosaicSlice"

export const zoomToOrtho = (entity: OrthoFlight) => {
    const state = store.getState()
    const dispatch = store.dispatch

    const uploads = selectOrthoImagesAndUploadsByFlightId(entity.id)(state)
    const isOrthoFlightShowLayers = selectOrthoFlightIsBoundingBoxShowing(entity.id)(state)

    const isJobReady = entity.job ? entity.job.status >= JobStatusType.COMPLETED : false

    dispatch(zoomToShowFlightPath(uploads))

    if (!isOrthoFlightShowLayers && isJobReady) {
        dispatch(toggleActiveOrthophoto(entity.id))
    }
    if (!isOrthoFlightShowLayers && !isJobReady) {
        dispatch(activateFlightPath({ flightId: entity.id }))
    }
    const projectId = selectActivatedFireId(state)!
    //we need to revisit when and how snapshots are being taken
    //updateMostRecentJobId()
    takeMapSnapshot(projectId)
}

export const shouldHideOrthoInspectorPanel = (entity: OrthoFlight) => {
    const state = store.getState()
    const uploads = selectOrthoImagesAndUploadsByFlightId(entity.id)(state)
    return !uploads || uploads.length === 0
}
